import { useTranslation } from 'react-i18next'

import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { LogaltyPending } from '@/Logalty/ui/molecules'

export const ContractNewProductsStep5PendingScreen = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <LogaltyPending
      description={t(
        productContractingTranslation.contractProductPage.confirmationScreen.pending
          .description,
      )}
    />
  )
}
